module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M14 6c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2s-2 .894-2 2v2c0 1.106.894 2 2 2zm6 0c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2s-2 .894-2 2v2c0 1.106.894 2 2 2zm6 0c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2s-2 .894-2 2v2c0 1.106.894 2 2 2zm4 2H10c-1.106 0-2 .894-2 2v2H6.062C2.718 12 0 14.692 0 18v4c0 3.308 2.692 6 6 6h2.37c.828 2.324 3.026 4 5.63 4h12c3.308 0 6-2.692 6-6V10c0-1.106-.894-2-2-2zM4 22v-4c0-1.084.946-2 2.062-2H8v8H6c-1.102 0-2-.898-2-2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/coffee-1.js
// module id = 1078
// module chunks = 14